import { createStyles, rem } from '@mantine/styles';
var useStyles = createStyles(function (theme) {
  return {
    divider: {
      marginTop: rem(4),
      marginBottom: rem(4),
      borderTop: "".concat(rem(1), " solid ").concat(theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[2])
    }
  };
});
export default useStyles;